export function convertThemeNameFromContentfulToCamelCase(
    theme: string | undefined
): string | undefined {
    if (!theme || theme === "Default") {
        return undefined;
    }

    return theme
        .toLowerCase()
        .trimStart()
        .trimEnd()
        .split(" ")
        .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
        .join("");
}
